import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="mx-auto max-w-[1360px] px-6 md:px-10 py-32" data-testid="not-found-page">
      <p className="eyebrow">Error 404</p>
      <h1 className="font-display text-6xl md:text-8xl mt-6">
        Nothing lives at this <em className="not-italic text-brand-red">address.</em>
      </h1>
      <p className="mt-6 max-w-prose text-lg text-ink-soft">
        The page you were looking for may have moved, or it never existed at all.
        Let&rsquo;s get you back to somewhere useful.
      </p>
      <div className="mt-10 flex flex-wrap gap-4">
        <Link
          to="/"
          className="inline-flex items-center gap-3 bg-ink text-paper px-6 py-4 hover:bg-electric transition-colors duration-200 font-ui"
        >
          Back to home <span aria-hidden>→</span>
        </Link>
        <Link to="/work" className="inline-flex items-center gap-3 border hairline-strong px-6 py-4 font-ui hover:border-ink">
          See selected work <span aria-hidden>→</span>
        </Link>
      </div>
    </section>
  );
}
